import api from "@/lib/api";

/**
 * Client-side keep-warm ping. While a signed-in user has the tab open, we hit
 * /api/health every 4 minutes so the deployed pod never goes cold on us.
 * Also re-pings immediately when the tab regains focus after a while.
 *
 * This is on top of the platform-side 20-min cron - together they keep the
 * container hot from both directions.
 */
const INTERVAL_MS = 4 * 60 * 1000;

let intervalId = null;
let lastPing = 0;

const ping = async () => {
  const now = Date.now();
  if (now - lastPing < 30_000) return; // debounce: never more than once every 30s
  lastPing = now;
  try {
    await api.get("/health");
  } catch {
    // silent — the retry interceptor already handles transient failures
  }
};

const onVisibility = () => {
  if (document.visibilityState === "visible") {
    ping();
  }
};

export function startKeepWarm() {
  if (intervalId) return;
  ping();
  intervalId = setInterval(ping, INTERVAL_MS);
  document.addEventListener("visibilitychange", onVisibility);
}

export function stopKeepWarm() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
  document.removeEventListener("visibilitychange", onVisibility);
}
